//Use getURLParamValue("<replace with param>"); to get value of a param in the URL
var URLobject = {};

const getURLParamValue = (URLparam) => {
	var URLarray = window.location.search.substring(1).split("&"),
        arrayLength = URLarray.length;

    for (var x = 0; x < arrayLength; x++) {
        var currentPair = URLarray[x].split("=");

        if (currentPair[0] === "df") currentPair[1] = unescape(currentPair[1]).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace("'", "&#x27").replace("%22", "&quot").replace("\"", "&quote;");

        URLobject[currentPair[0]] = currentPair[1];
    }
    return URLobject[URLparam] !== undefined ? URLobject[URLparam] : "";
};


export {getURLParamValue}
